import * as React from 'react'
import styled from '../../../common/src/components/styled'
import { getDataFromUrl } from '../location'
import { createWidget } from './base'

interface Props {
  score: string
  uuid: string
  contactId: string
  taskId: string
  comment?: string
}

class NpsSurvey extends React.PureComponent<Props> {
  componentDidMount() {
    // once rendered in the client, POST data to server
    fetch('/api/post_nps_survey', { method: 'POST', body: JSON.stringify(getDataFromUrl()) }).catch(err =>
      console.log(err)
    )
  }

  render() {
    return (
      <SurveyWrapper>
        <Header>
          <H1>{this.props.comment == null ? `OK. Why ${this.props.score}?` : 'Got it. Thanks for your feedback.'}</H1>
        </Header>
        {this.props.comment == null && <CommentForm {...this.props} />}
      </SurveyWrapper>
    )
  }
}
function CommentForm(props: Props) {
  return (
    <Form action={`/api/nps_survey?uuid=${props.uuid}`} method="get">
      <TextArea name="comment" placeholder={`I chose ${props.score} because …`} />
      <input type="hidden" name="uuid" value={props.uuid} />
      <input type="hidden" name="score" value={props.score} />
      <input type="hidden" name="contactId" value={props.contactId} />
      <input type="hidden" name="taskId" value={props.taskId} />
      <Input type="submit" value="Send feedback" />
    </Form>
  )
}

const npsWidgetId = 'nps-survey'
const npsWidget = createWidget(npsWidgetId, (props: Props) => <NpsSurvey {...props} />)

/**
 *
 * Provides server-rendered HTML widget after agent/boss clicks on 1-10 in their SEND_AUTO_NPS_SURVEY email.
 *
 * Allows us to collect a comment ("why did you choose X?") from boss/agent.
 */
export function getNpsSurveyResponseHTML(props: Props) {
  return npsWidget.renderHtml('Thanks for the feedback!', props)
}

/**
 * Hydrates server-rendered widget.
 */
export function hydrateNpsWidget() {
  // Only hydrate widget if it's actually rendered
  if (document.getElementById(npsWidgetId) == null) {
    return
  }

  return npsWidget.init(getDataFromUrl())
}

const SurveyWrapper = styled.div({
  width: '80%',
  minWidth: '300px',
  maxWidth: '600%',
  display: 'block',
  margin: '0 auto',
})

const Header = styled.header({
  margin: '3em 0 2em 0',
})

const H1 = styled.h1({
  display: 'inline-block',
  color: '#242426',
  fontSize: '32px',
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal',
  lineHeight: '1.5',
  margin: '0',
})

const Form = styled.form({
  display: 'flex',
  flexDirection: 'column',
})

const TextArea = styled.textarea({
  minWidth: '300px',
  margin: '0px 0px 16px 0px',
  padding: '4px 8px',
  height: '100px',
  backgroundColor: 'white',
  fontSize: '1.25em',
  border: '1px solid rgba(165, 163, 168, 0.5)',
  borderRadius: '2px',
  display: 'block',
})

const Input = styled.input({
  backgroundColor: '#07b5e3',
  color: '#101011',
  border: 'none',
  fontSize: '1.125em',
  padding: '16px 32px',
  textDecoration: 'none',
  cursor: 'pointer',
  borderRadius: '4px',
  alignSelf: 'flex-end',
})
